import { render, staticRenderFns } from "./IngredientList.vue?vue&type=template&id=5c416156&"
import script from "./IngredientList.vue?vue&type=script&lang=js&"
export * from "./IngredientList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports